<script setup lang="ts">
import { ref } from 'vue'
import { defineEmits, defineProps } from 'vue'
import GlobalSearchDialog from './GlobalSearchDialog.vue'

const props = defineProps<{
    drawer: boolean
    toggleDrawer: () => void
    user: any
    theme: string
}>()

const emit = defineEmits(['toggle-theme', 'logout'])
const shortcutItems = [
    { icon: 'mdi-calendar-outline', title: 'Calendar', subtitle: 'Appointments' },
    { icon: 'mdi-file-document-outline', title: 'Invoice App', subtitle: 'Manage Accounts' },
    { icon: 'mdi-account-outline', title: 'Users', subtitle: 'Manage Users' },
    { icon: 'mdi-shield-account', title: 'Role Management', subtitle: 'Permission' },
    { icon: 'mdi-chart-pie', title: 'Dashboard', subtitle: 'Analytics' },
    { icon: 'mdi-cog-outline', title: 'Settings', subtitle: 'Account Settings' },
]
// Active section tracking
const activeSection = ref('Dashboards')
const globalSearchVisible = ref(false)
</script>

<template>
    <v-app-bar class="bg-background pt-1" elevation="0">
        <!-- Left side: Logo and Menu Toggle -->
        <div class="d-flex align-center">
            <v-app-bar-nav-icon class="ml-2" variant="text" @click.stop="toggleDrawer()" />
            <v-img src="/path-to-materio-logo.svg" alt="Materio" max-width="120" class="ml-4"></v-img>

        </div>




        <!-- Right side: Action Icons -->
        <v-spacer></v-spacer>

        <div class="d-flex align-center mr-2">
            <!-- Search Icon -->
            <!-- <v-btn icon variant="text" class="mx-1" @click="globalSearchVisible = true">
                <v-icon>mdi-magnify</v-icon>
            </v-btn> -->


            <!-- Theme Toggle -->
            <v-btn icon variant="text" class="mx-1" @click="emit('toggle-theme')">
                <v-icon>{{ theme === 'myCustomDarkTheme' ? 'mdi-white-balance-sunny' : 'mdi-moon-waning-crescent'
                    }}</v-icon>
            </v-btn>

            <!-- Favorites -->
            <!-- <v-menu offset-y>
                <template #activator="{ props }">
                    <v-btn v-bind="props" icon variant="text" class="mx-1">
                        <v-icon>mdi-star-outline</v-icon>
                    </v-btn>
                </template>

                <v-card elevation="10" width="560" class="pa-4 rounded-lg">
                    <div class="d-flex justify-space-between align-center mb-4">
                        <span class="text-subtitle-1 font-weight-bold">Shortcuts</span>
                        <v-btn icon variant="text" size="small">
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </div>

                    <v-row dense>
                        <v-col cols="6" class="mb-2" v-for="(item, i) in shortcutItems" :key="i">
                            <v-sheet class="d-flex align-center pa-3 rounded-lg hover-sheet" elevation="0">
                                <v-avatar size="44" color="grey-lighten-4" class="mr-3">
                                    <v-icon color="primary">{{ item.icon }}</v-icon>
                                </v-avatar>
                                <div>
                                    <div class="font-weight-bold text-body-1">{{ item.title }}</div>
                                    <div class="text-caption text-medium-emphasis">{{ item.subtitle }}</div>
                                </div>
                            </v-sheet>
                        </v-col>
                    </v-row>
                </v-card>
            </v-menu> -->

            <!-- Notifications -->
            <!-- <v-btn icon variant="text" class="mx-1" color="primary">
                <v-badge dot color="error">
                    <v-icon>mdi-bell-outline</v-icon>
                </v-badge>
            </v-btn> -->

            <!-- User Profile Menu -->
            <v-menu :close-on-content-click="false" location="bottom">
                <template #activator="{ props: menuProps }">
                    <div v-bind="menuProps" class="d-flex align-center mx-2 cursor-pointer">
                        <v-avatar size="32" color="primary" class="mr-2">
                            <v-img v-if="props.user?.avatar" :src="props.user.avatar"></v-img>
                            <span v-else class="text-subtitle-1">{{ props.user?.name?.substring(0, 1) ?? '?' }}</span>
                        </v-avatar>
                        <v-badge color="success" dot offset-x="2" offset-y="2" location="bottom end" bordered>
                        </v-badge>
                    </div>
                </template>

                <v-card min-width="300" class="pa-3" elevation="4">
                    <v-list>
                        <v-list-item :subtitle="props.user?.email" :title="props.user?.name">
                            <template #append>
                                <v-btn class="mx-3" icon="mdi-account-circle" to="/user" variant="text" />
                            </template>
                        </v-list-item>
                    </v-list>
                    <v-divider />
                    <v-card-actions>
                        <v-spacer />
                        <v-btn variant="text" rounded @click="emit('logout')">Desconectar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-menu>
        </div>

        <GlobalSearchDialog v-model="globalSearchVisible" />
    </v-app-bar>
</template>
<style scoped>
.shortcut-btn {
    transition: background-color 0.3s ease;
}

.shortcut-btn:hover {
    background-color: rgba(0, 0, 0, 0.05);
}

.hover-sheet {
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.hover-sheet:hover {
    background-color: rgba(0, 0, 0, 0.06);
}
</style>